import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSocket } from '../contexts/SocketContext';
import { useTheme } from '../contexts/ThemeContext';
import { useActiveMatch } from '../contexts/ActiveMatchContext';
import { getRankInfo } from '../rank';

const API = process.env.REACT_APP_API_URL || '';

function MoonIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
    </svg>
  );
}
function SunIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
      <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd"/>
    </svg>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const { connected } = useSocket();
  const { darkMode, toggleDarkMode } = useTheme();
  const { activeMatch } = useActiveMatch();
  const loc = useLocation();
  const inMatch = !!activeMatch?.gameId;

  return (
    <>
      {!connected && user && (
        <div className="conn-banner">Reconnecting to server…</div>
      )}
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          <img src="/RANKEDSATLOGO.png" alt="rSAT" style={{ height: 'auto', width: 160, objectFit: 'contain', display: 'block' }} />
        </Link>

        <div style={{ display: 'flex', gap: 4, opacity: inMatch ? 0.4 : 1, pointerEvents: inMatch ? 'none' : 'auto', transition: 'opacity .2s' }}>
          <Link to="/" className={`navbar-link${loc.pathname === '/' ? ' active' : ''}`}>Home</Link>
          <Link to="/leaderboard" className={`navbar-link${loc.pathname === '/leaderboard' ? ' active' : ''}`}>Leaderboard</Link>
          <Link to="/learn" className={`navbar-link${loc.pathname === '/learn' ? ' active' : ''}`}>Learn</Link>
          <Link to="/about" className={`navbar-link${loc.pathname === '/about' ? ' active' : ''}`}>About</Link>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdnJtO6X66IImNTmIVCOPmgIqhssT5Nx-Jgpvhsbu9QNuIRrw/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-link"
          >Help</a>

          {user?.is_admin && (
            <Link to="/admin" className={`navbar-link${loc.pathname === '/admin' ? ' active' : ''}`} style={{ color: 'rgba(255,70,85,.95)', fontWeight: 700 }}>🛡️ Admin</Link>
          )}
        </div>

        <div className="navbar-right">
          <Link to="/profile" className="navbar-user" style={{ position: 'relative', textDecoration: 'none' }}>
            {user?.avatar && <img src={user.avatar} alt="" className="navbar-avatar" />}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0, maxWidth: 180 }}>
                {user && (() => {
                  const r = getRankInfo(user.rating ?? 0);
                  return (
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: 3, flexShrink: 0,
                      background: 'rgba(255,255,255,0.12)', borderRadius: 5,
                      padding: '1px 5px 1px 4px', fontSize: 11, fontWeight: 800,
                      color: r.color,
                    }}>
                      {r.level}
                      <img src={r.icon} alt={r.label} title={r.label} style={{ width: 16, height: 16, objectFit: 'contain' }} />
                    </span>
                  );
                })()}
                <span style={{ fontSize: 13, color: 'rgba(255,255,255,.9)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
                  {user?.display_name || user?.name}
                </span>
              </span>
              {user?.school && (
                <span className="school-flair school-flair-sm">{user.school}</span>
              )}
            </div>
          </Link>
          <button
            className="btn btn-ghost btn-sm navbar-theme-btn"
            onClick={toggleDarkMode}
            title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {darkMode ? <SunIcon /> : <MoonIcon />}
          </button>
          <button className="btn btn-ghost btn-sm" style={{ color: 'rgba(255,255,255,.6)', fontSize: 13 }} onClick={logout}>
            Sign out
          </button>
        </div>
      </nav>
    </>
  );
}
